var API_DOMAIN = "https://ayyansrikrishnafinance.zentexus.com/api";
// var API_DOMAIN = "http://localhost/ayyan_krishna_finance_api/api";

export default API_DOMAIN;
